import { gql } from 'graphql-tag';

import type { GqlClient } from '@change-corgi/core/gql';

import type { FeCoreTreatExperimentMutation, FeCoreTreatExperimentMutationVariables } from './api.graphql';

export async function treatExperiment(id: string, context: { gqlFetch: GqlClient['fetch'] }): Promise<void> {
	try {
		await context.gqlFetch<FeCoreTreatExperimentMutation, FeCoreTreatExperimentMutationVariables>({
			query: gql`
				mutation FeCoreTreatExperiment($id: ID!) {
					treatExperiment(id: $id) {
						id
					}
				}
			`,
			variables: { id },
		});
	} catch (e) {
		// error already reported by shared/gql
	}
}
